<template>
  <div class="contenidor">
    <dl>
      <dt @click="selectNewKeycard()">
        <inline-svg v-if="active == 1" class="icon" src="/img/icons/icon-radio-active.svg" />
        <img v-else class="icon" src="/img/icons/icon-radio.svg">
        <div class="text">{{ $t('participants.keycard.insert') }}</div>
      </dt>
      <dd v-if="active == 1">
        <ria-input
          id="input-keycard"
          type="text"
          subtype="input-keycard"
          name="keycard"
          :label="$t('participants.keycard.add')"
          validation="required|validatekeycard"
          :validationCustomRules="validationCustomRules"
          :validationCustomMessages="validationmessage"
          @change="changeKeycardValue" />
        <div class="keycard-helper">{{ $t('participants.keycard.helper') }}</div>
      </dd>
    </dl>

    <dl v-if="!isAnonymous && Object.keys(customer).length > 0 && customer.keycards.length > 0">
      <dt @click="selectExistingKeycard()">
        <inline-svg v-if="active == 2" class="icon" src="/img/icons/icon-radio-active.svg" />
        <img v-else class="icon" src="/img/icons/icon-radio.svg">
        <div class="text">{{ $t('participants.keycard.select') }}</div>
      </dt>
      <dd class="wrapper_options" v-if="active == 2">
        <keycard-option v-for="(customerKeycard,i) in customer.keycards"
          :key="customerKeycard.id"
          :index="i"
          :isactive="keycardoptionactive === i"
          @optionSelected="updateKeycardOption"
          :keycard="customerKeycard" />
      </dd>
    </dl>

  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import RiaInput from "@/components/form/elements/ria-input";
  import KeycardOption from "@/components/form/elements/keycard-option";
  import { apiClient } from "@/api";
  import i18n from "@/i18n";

  export default {
    name: "keycard-accordion",
    components: {RiaInput,KeycardOption},
    data: function() {
      return {
        active: null,
        keycardoptionactive: null,
        keycard: Object,
        validationmessage: Object,
        validationCustomRules: Object,
        i18n: i18n,
      }
    },
    created() {
      this.validationmessage = { validatekeycard: i18n.t('participants.keycard.invalid') }
      this.validationCustomRules = { validatekeycard: async ({ value }) => {
        if (value && value.length >= 16) {
          const validation = await apiClient.validateKeyCard(this.resort.id,value);
          let keycardFound = false;
          if (this.customer.keycards) {
            keycardFound = this.customer.keycards.some(keycard => keycard.number === value)
            if (keycardFound) {
              this.validationmessage.validatekeycard = i18n.t('participants.keycard.exists')
            }
          }
          return validation.data && !keycardFound === true
        }
      }}
      this.selectNewKeycard();
    },
    computed: {
      ...mapGetters("auth", ["isAnonymous"]),
      ...mapGetters("customer", ["customer"]),
      ...mapGetters("resort", ["resort"]),
    },
    methods: {
      selectNewKeycard: function() {
        this.active = 1;
        this.keycardoptionactive = null;
        this.keycard = null;
      },
      selectExistingKeycard: function() {
        this.active = 2;
      },
      changeKeycardValue: function({ value, hasErrors }) {
        if (hasErrors) {
          this.keycard = null;
          this.$emit('keycard', null);
        } else {
          this.keycard = {};
          this.$emit('keycard', { "number": value });
          this.keycard.number = value;
        }
      },
      updateKeycardOption: function({ selected, value }){
        this.keycardoptionactive = selected;
        this.keycard = {};
        this.$emit('keycard', { "number": value });
        this.keycard.number = value;
      }
    }
  };
</script>

<style scoped lang="scss">
  .contenidor {
    @apply px-5 bg-white;
  }

  dl {
    @apply border-b-1 border-grey-border pb-1;
  }

  dl:last-child {
    @apply border-0;
  }

  dt {
    @apply py-5 flex justify-between h-16;
  }

  dd {
    @apply ml-8 mb-8 mt-minus3 text-left text-sm font-light;
    &.wrapper_options {
      @apply m-0 pb-5;
    }
  }

  .keycard-helper {
    @apply p-4 text-grey-text bg-yellow;
  }

  .icon {
    @apply w-6 h-6 object-contain flex-grow-0 mr-2;
  }

  .text {
    @apply text-sm text-black text-left flex-grow;
  }

  .aux-text {
    @apply text-sm text-grey-text text-left;
  }

</style>
<style>
  #input-keycard input::placeholder{
    @apply text-grey-separator !important
  }
  #input-keycard .skitude-input-error::placeholder{
    color: #ff4e60 !important
  }
</style>
